export const LOADER_STATUS = 'boilderplate/CashBalance/LOADER_STATUS';
export const PROFILE_DATA = 'boilderplate/CashBalance/PROFILE_DATA';
export const SET_ENTITY_LIST = 'boilderplate/Summary/SET_ENTITY_LIST';